var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9616 23.9401H24.5616C19.7981 23.9401 15.9366 27.88 15.9366 32.7401V64.42C15.9366 69.2801 19.7981 73.22 24.5616 73.22H65.9616C70.725 73.22 74.5866 69.2801 74.5866 64.42V32.7401C74.5866 27.88 70.725 23.9401 65.9616 23.9401ZM24.5616 18.6601C16.9401 18.6601 10.7616 24.9639 10.7616 32.7401V64.42C10.7616 72.1962 16.9401 78.5 24.5616 78.5H65.9616C73.5831 78.5 79.7616 72.1962 79.7616 64.42V32.7401C79.7616 24.9639 73.5831 18.6601 65.9616 18.6601H24.5616Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4616 12.5C32.8906 12.5 34.0491 13.682 34.0491 15.14V18.66C34.0491 20.118 32.8906 21.3 31.4616 21.3C30.0326 21.3 28.8741 20.118 28.8741 18.66V15.14C28.8741 13.682 30.0326 12.5 31.4616 12.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0616 12.5C60.4907 12.5 61.6491 13.682 61.6491 15.14V18.66C61.6491 20.118 60.4907 21.3 59.0616 21.3C57.6326 21.3 56.4741 20.118 56.4741 18.66V15.14C56.4741 13.682 57.6326 12.5 59.0616 12.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.788 32.7399H30.7353C29.2464 32.7399 28.0116 33.9367 28.0116 35.3799C28.0116 36.8231 29.2464 38.0199 30.7353 38.0199H59.788C61.2769 38.0199 62.5116 36.8231 62.5116 35.3799C62.5116 33.9367 61.2769 32.7399 59.788 32.7399Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.a76431f7.svg";
export { ForwardRef as ReactComponent };